const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.56 25.97H14.44C10.46 25.97 9.25 24.76 9.25 20.78V14.44C9.25 10.46 10.46 9.25 14.44 9.25H25.55C29.53 9.25 30.74 10.46 30.74 14.44V20.77C30.75 24.76 29.54 25.97 25.56 25.97ZM14.44 10.75C11.3 10.75 10.75 11.3 10.75 14.44V20.77C10.75 23.91 11.3 24.46 14.44 24.46H25.55C28.69 24.46 29.24 23.91 29.24 20.77V14.44C29.24 11.3 28.69 10.75 25.55 10.75H14.44Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.7497C19.59 30.7497 19.25 30.4097 19.25 29.9997V25.2197C19.25 24.8097 19.59 24.4697 20 24.4697C20.41 24.4697 20.75 24.8097 20.75 25.2197V29.9997C20.75 30.4097 20.41 30.7497 20 30.7497Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 21.75H10C9.59 21.75 9.25 21.41 9.25 21C9.25 20.59 9.59 20.25 10 20.25H30C30.41 20.25 30.75 20.59 30.75 21C30.75 21.41 30.41 21.75 30 21.75Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 30.75H15.5C15.09 30.75 14.75 30.41 14.75 30C14.75 29.59 15.09 29.25 15.5 29.25H24.5C24.91 29.25 25.25 29.59 25.25 30C25.25 30.41 24.91 30.75 24.5 30.75Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorBlue);
export default __webpack_public_path__ + "static/media/monitor-blue.a8714cabc9eb2e61c4030b1ae8e2ea81.svg";
export { ForwardRef as ReactComponent };